<template>
  <v-card class="rounded-pill text-center">
    <v-progress-circular
      class="ma-1"
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-circular>
    <!-- Button to trigger a search in a bbox -->
    <v-list v-else-if="isMapHadMoved && !switchData" dense class="pa-0">
      <v-list-item @click="$emit('searchInThisArea')">
        <v-icon color="primary" size="16px" class="mr-3">fas fa-redo</v-icon>
        <v-list-item-content
          v-html="$t('search.searchInThisArea')"
          class="text-body-2 primary--text text-center"
        ></v-list-item-content>
      </v-list-item>
    </v-list>
    <!-- Switch to allow search new post when the map is moved -->
    <v-switch
      v-else
      v-model="switchData"
      color="primary"
      class="ma-0 pa-2"
      :hide-details="true"
    >
      <template v-slot:label>
        <span class="text-body-2 primary--text text-center">{{
          $t("search.searchIfMapMove")
        }}</span>
      </template>
    </v-switch>
  </v-card>
</template>

<script>
export default {
  name: "TheSearchNewSearchOnScrollingButton",
  props: {
    isMapHadMoved: Boolean,
    loading: Boolean
  },
  data() {
    return {
      switchData: false
    };
  },
  watch: {
    switchData() {
      this.$emit("switchSearchIfMapMove");
    }
  }
};
</script>

<style scoped></style>
